import { useEffect, useState } from "react";
import Select from "react-select";
// styles
import "../../project/Project.css";
//gobal
import {
  accountDataStore,
  companyStore,
  dbDataStore,
} from "../../../store/Store";
// components
import AccountCustomerInvoiceListRows from "./AccountCustomerInvoiceListRows";
import UpdatePopup from "../../../components/UpdatePopup";
import DeletePopup from "../../../components/DeletePopup";
// data
import {
  invoiceStatus,
  invoiceStatusFilterMap,
} from "../../../data/collections-data";
import SearchBar from "../../../components/SearchBar";
import useGetFetch from "../../../hooks/useGetFetch";
import ErrorDisplay from "../../../components/ErrorDisplay";
import Loading from "../../../components/Loading";
import AccountCustomerTieredWeightsCard from "./AccountCustomerTieredWeightsCard";
import InvoiceStatusFilter from "../../../invoiceComponents/InvoiceStatusFilter";

export default function AccountCustomerInvoiceList({ isAsset, isTier }) {
  // gobal
  const accountCustomerInvoices = accountDataStore(
    (data) => data.accountCustomerInvoices,
  );
  const setAccountCustomerInvoices = accountDataStore(
    (data) => data.setAccountCustomerInvoices,
  );
  const setAccountCustomerInvoiceTotals = accountDataStore(data => data.setAccountCustomerInvoiceTotals)
  const companyData = dbDataStore((data) => data.companyData);
  const setInvoiceCounts = companyStore((data) => data.setInvoiceCounts);
  const invoiceCounts = companyStore((data) => data.invoiceCounts);

  // local
  const [invoicesExist, setInvoicesExist] = useState({
    freight: false,
    asset: false,
    tiered: false,
  });
  const [body, setBody] = useState();
  const [trigger, setTrigger] = useState(false);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [displayInvoices, setDisplayInvoices] = useState([]);
  const [filter, setFilter] = useState("in_progress");
  const [customerDD, setCustomerDD] = useState([]);
  const [totalTieredHauled, setTotalTieredHauled] = useState([]);
  const [selectValue, setSelectValue] = useState({
    value: 0,
    label: "All Customers",
  });
  const [deleteTrigger, setDeleteTrigger] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  const { isPending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/lc/invoice-counts/0`,
    setInvoiceCounts,
  );
  const { isPending: hauledPending, error: hauledError } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/pc/tiered-hauled`,
    setTotalTieredHauled,
  );

  // get customer dd
  useEffect(() => {
    const dd = [{ value: 0, label: "All Customers" }];
    if (accountCustomerInvoices && accountCustomerInvoices.customer_invoices) {
      accountCustomerInvoices.customer_invoices.forEach((inv) => {
        const exist = dd.filter((x) => x.value === inv.customer_id);
        if (exist.length === 0) {
          let name = companyData.filter((x) => x.id === inv.customer_id)[0]
            .company_name;
          dd.push({ value: inv.customer_id, label: name });
        }
      });
    }
    setCustomerDD(dd);
  }, [accountCustomerInvoices, companyData]);

  // determine if freight and asset invoices exist
  useEffect(() => {
    if (accountCustomerInvoices) {
      const freight = accountCustomerInvoices.filter(
        (x) => !x.is_asset && !x.is_tier,
      );
      const asset = accountCustomerInvoices.filter(
        (x) => x.is_asset && !x.is_tier,
      );
      const tiered = accountCustomerInvoices.filter(
        (x) => x.is_tier && !x.is_asset,
      );
      if (freight.length > 0) {
        setInvoicesExist((current) => ({
          ...current,
          freight: true,
        }));
      }
      if (asset.length > 0) {
        setInvoicesExist((current) => ({
          ...current,
          asset: true,
        }));
      }
      if (tiered.length > 0) {
        setInvoicesExist((current) => ({
          ...current,
          tiered: true,
        }));
      }
    }
  }, [accountCustomerInvoices]);

  // filter invoices
  useEffect(() => {
    var invoices;
    setSelectValue({ value: 0, label: "All Customers" });
    if (
      accountCustomerInvoices &&
      !isAsset &&
      !isTier
    ) {
      switch (filter) {
        case "in_progress":
          invoices = accountCustomerInvoices.filter(
            (x) =>
              (x.invoice_status_id === 25 || x.invoice_status_id === 21) &&
              !x.is_asset &&
              !x.is_tier,
          );
          break;
        case "approved":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 23 && !x.is_asset && !x.is_tier,
          );
          break;
        case "paid":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 24 && !x.is_asset && !x.is_tier,
          );
          break;
        case "disputed":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 22 && !x.is_asset && !x.is_tier,
          );
          break;
        default:
          invoices = accountCustomerInvoices.filter(
            (x) =>
              (x.invoice_status_id === 25 || x.invoice_status_id === 21) &&
              !x.is_asset &&
              !x.is_tier,
          );
      }
    } else if (
      accountCustomerInvoices &&
      isAsset
    ) {
      switch (filter) {
        case "in_progress":
          invoices = accountCustomerInvoices.filter(
            (x) =>
              (x.invoice_status_id === 25 || x.invoice_status_id === 21) &&
              x.is_asset &&
              !x.is_tier,
          );
          break;
        case "approved":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 23 && x.is_asset && !x.is_tier,
          );
          break;
        case "paid":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 24 && x.is_asset && !x.is_tier,
          );
          break;
        case "disputed":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 22 && x.is_asset && !x.is_tier,
          );
          break;
        default:
          invoices = accountCustomerInvoices.filter(
            (x) =>
              (x.invoice_status_id === 25 || x.invoice_status_id === 21) &&
              x.is_asset &&
              !x.is_tier,
          );
      }
    } else if (
      accountCustomerInvoices &&
      isTier
    ) {
      switch (filter) {
        case "in_progress":
          invoices = accountCustomerInvoices.filter(
            (x) =>
              (x.invoice_status_id === 25 || x.invoice_status_id === 21) &&
              x.is_tier &&
              !x.isAsset,
          );
          break;
        case "approved":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 23 && x.is_tier && !x.isAsset,
          );
          break;
        case "paid":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 24 && x.is_tier && !x.isAsset,
          );
          break;
        case "disputed":
          invoices = accountCustomerInvoices.filter(
            (x) => x.invoice_status_id === 22 && x.is_tier && !x.isAsset,
          );
          break;
        default:
          invoices = accountCustomerInvoices.filter(
            (x) =>
              (x.invoice_status_id === 25 || x.invoice_status_id === 21) &&
              x.is_tier &&
              !x.isAsset,
          );
      }
    }
    setFilteredInvoices(invoices);
    setDisplayInvoices(invoices);
  }, [filter, accountCustomerInvoices, isAsset, isTier]);

  const handleSelect = (o) => {
    setSelectValue(o);
    switch (o.value) {
      case 0:
        setDisplayInvoices(filteredInvoices);
        break;
      default:
        if (accountCustomerInvoices) {
          let invoices = filteredInvoices.filter(
            (x) => x.customer_id === o.value,
          );
          setDisplayInvoices(invoices);
        }
        break;
    }
  };

  if (error || hauledError) {
    return <ErrorDisplay message={"Could not get invoice counts"} code={500} />;
  } else if (isPending || hauledPending) {
    return <Loading />;
  }
  if (!accountCustomerInvoices) {
    return <p className="no-docs-added">No Invoices Have Been Added</p>;
  } else {
    return !isAsset && invoicesExist.freight && !isTier ? (
      <div>
        <div className="d-flex justify-content-between">
          <InvoiceStatusFilter
            setFilter={setFilter}
            invoiceCounts={invoiceCounts.customer_freight_counts}
          />
          <SearchBar
            data={filteredInvoices}
            field={"invoice_name"}
            setData={setDisplayInvoices}
          />
          <Select
            key={"customer"}
            name={"customer"}
            options={customerDD}
            onChange={handleSelect}
            placeholder={"Customers"}
            value={selectValue}
            className="search-select"
          />
        </div>
        {displayInvoices.length > 0 ? (
          <div className="load-display-list">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Customer</th>
                  <th>Start</th>
                  <th>End</th>
                  {(filter === "approved" || filter === "paid") && (
                    <th>Approval Date</th>
                  )}
                  <th>Loads</th>
                  <th>Weight (tons)</th>
                  <th>Calc Weight (tons)</th>
                  <th>Weight Diff (tons)</th>
                  <th>Rev</th>
                  <th>Calc Rev</th>
                  <th>Rev Diff</th>
                  <th>Cost</th>
                  <th>Calc Cost</th>
                  <th>Cost Diff</th>
                  <th>Profit</th>
                  <th>Margin</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <AccountCustomerInvoiceListRows
                  isAsset={isAsset}
                  isTier={isTier}
                  setBody={setBody}
                  setTrigger={setTrigger}
                  invoices={displayInvoices}
                  setDeleteTrigger={setDeleteTrigger}
                  setDeleteId={setDeleteId}
                  filter={filter}
                />
              </tbody>
            </table>
          </div>
        ) : (
          <p className="no-docs-added">{`No ${invoiceStatusFilterMap[filter]} Invoices Exist`}</p>
        )}
        {trigger && (
          <UpdatePopup
            setTrigger={setTrigger}
            url={`${process.env.REACT_APP_BACKEND}/pc/account-invoice/${body.id}`}
            method={"PATCH"}
            title={
              body.invoice_status !== 22
                ? `Are you sure you want to update ${body.invoice_name} to ${
                    invoiceStatus[body.invoice_status]
                  }`
                : `Updating ${body.invoice_name} to ${
                    invoiceStatus[body.invoice_status]
                  } will delete all associated unpaid vendor invoices, do you want to proceed?`
            }
            errorMessage={"Could not Update"}
            successMessage={"Status Changed"}
            setStates={[setAccountCustomerInvoices, setAccountCustomerInvoiceTotals, setInvoiceCounts]}
            setStateFields={["customer_invoices", "customer_invoice_totals", "invoice_counts"]}
            body={body}
            invoice={true}
          />
        )}
        {deleteTrigger && (
          <DeletePopup
            setTrigger={setDeleteTrigger}
            id={deleteId}
            table={"account_customer_invoice_tbl"}
            endpoint={"account-customer-invoices"}
            nameField={"invoice_name"}
            projectId={0}
            setDocId={setDeleteId}
            setStates={[setAccountCustomerInvoices, setAccountCustomerInvoiceTotals, setInvoiceCounts]}
            setStateFields={["customer_invoices", "customer_invoice_totals", "invoice_counts"]}
          />
        )}
      </div>
    ) : invoicesExist.asset && isAsset && !isTier ? (
      <div>
        <div className="d-flex justify-content-between">
          <InvoiceStatusFilter
            setFilter={setFilter}
            invoiceCounts={invoiceCounts.customer_asset_counts}
          />
          <SearchBar
            data={filteredInvoices}
            field={"invoice_name"}
            setData={setDisplayInvoices}
          />
          <Select
            key={"customer"}
            name={"customer"}
            options={customerDD}
            onChange={handleSelect}
            placeholder={"Customers"}
            value={selectValue}
            className="search-select"
          />
        </div>
        {displayInvoices.length > 0 ? (
          <div className="load-display-list">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Customer</th>
                  <th>Start</th>
                  <th>End</th>
                  {(filter === "approved" || filter === "paid") && (
                    <th>Approval Date</th>
                  )}
                  <th>Loads</th>
                  <th>Weight (tons)</th>
                  <th>Calc Weight (tons)</th>
                  <th>Weight Diff (tons)</th>
                  <th>Rev</th>
                  <th>Calc Rev</th>
                  <th>Rev Diff</th>
                  <th>Cost</th>
                  <th>Calc Cost</th>
                  <th>Cost Diff</th>
                  <th>Profit</th>
                  <th>Margin</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <AccountCustomerInvoiceListRows
                  isAsset={isAsset}
                  isTier={isTier}
                  setBody={setBody}
                  setTrigger={setTrigger}
                  invoices={displayInvoices}
                  setDeleteTrigger={setDeleteTrigger}
                  setDeleteId={setDeleteId}
                  filter={filter}
                />
              </tbody>
            </table>
          </div>
        ) : (
          <p className="no-docs-added">{`No ${invoiceStatusFilterMap[filter]} Invoices Exist`}</p>
        )}
        {trigger && (
          <UpdatePopup
            setTrigger={setTrigger}
            url={`${process.env.REACT_APP_BACKEND}/pc/account-invoice/${body.id}`}
            method={"PATCH"}
            title={
              body.invoice_status !== 22
                ? `Are you sure you want to update ${body.invoice_name} to ${
                    invoiceStatus[body.invoice_status]
                  }`
                : `Updating ${body.invoice_name} to ${
                    invoiceStatus[body.invoice_status]
                  } will delete all associated unpaid vendor invoices, do you want to proceed?`
            }
            errorMessage={"Could not Update"}
            successMessage={"Status Changed"}
            setStates={[setAccountCustomerInvoices, setAccountCustomerInvoiceTotals, setInvoiceCounts]}
            setStateFields={["customer_invoices", "customer_invoice_totals", "invoice_counts"]}
            body={body}
            acInvoice={true}
          />
        )}
        {deleteTrigger && (
          <DeletePopup
            setTrigger={setDeleteTrigger}
            id={deleteId}
            table={"account_customer_invoice_tbl"}
            endpoint={"account-customer-invoices"}
            nameField={"invoice_name"}
            projectId={0}
            setDocId={setDeleteId}
            setStates={[setAccountCustomerInvoices, setAccountCustomerInvoiceTotals, setInvoiceCounts]}
            setStateFields={["customer_invoices", "customer_invoice_totals", "invoice_counts"]}
          />
        )}
      </div>
    ) : !invoicesExist.asset && isAsset ? (
      <p className="no-docs-added">No Invoices Have Been Added</p>
    ) : isTier && invoicesExist.tiered ? (
      <div>
        {totalTieredHauled && totalTieredHauled.length > 0 && (
          <AccountCustomerTieredWeightsCard
            totalTieredHauled={totalTieredHauled}
          />
        )}
        <div className="d-flex justify-content-between">
          <InvoiceStatusFilter
            setFilter={setFilter}
            invoiceCounts={invoiceCounts.customer_tiered_counts}
          />
          <SearchBar
            data={filteredInvoices}
            field={"invoice_name"}
            setData={setDisplayInvoices}
          />
          <Select
            key={"customer"}
            name={"customer"}
            options={customerDD}
            onChange={handleSelect}
            placeholder={"Customers"}
            value={selectValue}
            className="search-select"
          />
        </div>
        {displayInvoices.length > 0 ? (
          <div className="load-display-list">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Customer</th>
                  <th>Month</th>
                  <th>Year</th>
                  <th>Loads</th>
                  <th>Weight (tons)</th>
                  <th>Rev</th>
                  <th>Tiered Weight</th>
                  <th>Billed Weight</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <AccountCustomerInvoiceListRows
                  isAsset={isAsset}
                  isTier={isTier}
                  setBody={setBody}
                  setTrigger={setTrigger}
                  invoices={displayInvoices}
                  setDeleteTrigger={setDeleteTrigger}
                  setDeleteId={setDeleteId}
                />
              </tbody>
            </table>
          </div>
        ) : (
          <p className="no-docs-added">{`No ${invoiceStatusFilterMap[filter]} Invoices Exist`}</p>
        )}
        {trigger && (
          <UpdatePopup
            setTrigger={setTrigger}
            url={`${process.env.REACT_APP_BACKEND}/pc/account-invoice/${body.id}`}
            method={"PATCH"}
            title={
              body.invoice_status !== 22
                ? `Are you sure you want to update ${body.invoice_name} to ${
                    invoiceStatus[body.invoice_status]
                  }`
                : `Updating ${body.invoice_name} to ${
                    invoiceStatus[body.invoice_status]
                  } will delete all associated unpaid vendor invoices, do you want to proceed?`
            }
            errorMessage={"Could not Update"}
            successMessage={"Status Changed"}
            setStates={[setAccountCustomerInvoices, setAccountCustomerInvoiceTotals, setInvoiceCounts]}
            setStateFields={["customer_invoices", "customer_invoice_totals", "invoice_counts"]}
            body={body}
          />
        )}
        {deleteTrigger && (
          <DeletePopup
            setTrigger={setDeleteTrigger}
            id={deleteId}
            table={"account_customer_invoice_tbl"}
            endpoint={"account-customer-invoices"}
            nameField={"invoice_name"}
            projectId={0}
            setDocId={setDeleteId}
            setStates={[setAccountCustomerInvoices, setAccountCustomerInvoiceTotals, setInvoiceCounts]}
            setStateFields={["customer_invoices", "customer_invoice_totals", "invoice_counts"]}
          />
        )}
      </div>
    ) : (
      <p className="no-docs-added">No Invoices Have Been Added</p>
    );
  }
}
